import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { TokenData } from 'src/app/model/api/token-data';
import { Lang } from 'src/app/model/lang';
import { FormBuilder } from '@angular/forms';
import * as UserActions from 'src/app/store/user/user.actions';
import { ActivatedRoute } from '@angular/router';

@Component({
   selector: 'app-list-device-support-no-auth',
   templateUrl: './list-device-support-no-auth.component.html',
   changeDetection: ChangeDetectionStrategy.Default,
   providers: [DialogService]
})

export class ListDeviceSupportComponentNoAuthComponent implements OnInit, OnDestroy {
   // Observables and subscriptions
   tokenData: TokenData;
   tokenSave: TokenData;
   tokenSub: Subscription;
   language: string;
   lang: Lang;

   ref: DynamicDialogRef | undefined;

   // design
   screenWidth: number;
   MIN_MD_WIDTH = 500;
   MAX_MD_WIDTH = 1120;
   MIN_WIDTH_MX7 = 1700;
   MIN_WIDTH_COL4 = 1530;
   LG_WIDTH = 1500;

   constructor(
      private store: Store<AppState>,
      public dialogService: DialogService,
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
   ) {
      this.initSelectors();
   }

   ngOnInit() {
      this.store.dispatch(NotificationsActions.setTopbarTitleId({
         stringId: 'HELPER'
      }));
      this.language = 'en-US';
      const langRest = this.route.snapshot.queryParamMap.get('language');
      const token = this.route.snapshot.queryParamMap.get('token');
      if (langRest != null) {
         this.language = langRest;
      }

      this.lang = {
         code: this.language,
         name: this.language,
      };
      this.store.dispatch(UserActions.setCurrentLang({ lang: this.lang }));


      this.tokenData = {
         access_token: token,
         expires_in: 7000,
         refresh_token: '',
         token_type: 'bearer',
         error: null,
      };
      this.store.dispatch(AuthActions.setUserToken({ tokenData: this.tokenData }));
      this.subscribeAll();
   }

   ngOnDestroy(): void {
      this.tokenSub?.unsubscribe();
   }

   initSelectors(): void {
      // Store selectors
   }

   subscribeAll(): void {
   }

   // Design
   @HostListener('window:resize', ['$event'])
   onResize(): void {
      this.screenWidth = window.innerWidth;
   }

   layoutMarginResponsive(): string {
      return (this.screenWidth >= this.MIN_WIDTH_MX7) ? "mx-7" : "mx-2";
   }
}